import { layerClass } from "@freightsimple/ui-core/Theme/layers";
import type { ReactNode } from "react";

/**
 * Break-glass. The public tracking card deliberately rides up over the map
 * above it — a negative offset plus a stacking context so it draws on top —
 * and caps its own width. Nothing in ui-core can overlap the preceding block,
 * so this one wrapper keeps its classes; everything inside it is components.
 *
 * `width` picks the cap: the shipment page needs the full page rhythm, while
 * the group list holds cards that stop at 1024px and looks padded at more.
 * Kept as literal classes so Tailwind's JIT can see both.
 */
type OverlapCardWidth = "page" | "list";

const widthClasses: Record<OverlapCardWidth, string> = {
  page: "max-w-[1216px]",
  list: "max-w-[1088px]",
};

interface TrackingOverlapCardProps {
  children: ReactNode;
  width?: OverlapCardWidth | undefined;
}

export function TrackingOverlapCard({
  children,
  width = "page",
}: TrackingOverlapCardProps) {
  return (
    <div
      className={`relative -top-[72px] ${layerClass.raised} w-full ${widthClasses[width]} rounded-[3px] border border-border-strong bg-card p-12 pt-6`}
    >
      {children}
    </div>
  );
}
